import React, { createContext, useEffect, useState } from "react";
import instance from "../instance/AxiosInstance";

export const AddContext = createContext();

export const AddProvider = ({ children }) => {
    const [AddData, SetAddData] = useState([])


    
    useEffect(() => {
      
        const fetchAdvertisements = async () => {
            try {
                const response = await instance.get('http://localhost:8080/api/user/product/get_Advertisements');
                SetAddData(response.data);  
            } catch (error) {
                console.log('Error fetching advertisements'); 
            }
        };

        fetchAdvertisements();
    }, []);

    return (
        <AddContext.Provider value={{ AddData, SetAddData }}>
            {children}

        </AddContext.Provider>
    )
}   